<template>
  <div class="jl-auc-success-wrap">
    <div class="jl-container">
      <v-breadcrumbs></v-breadcrumbs>
      <div class="jl-auc-success-content">
        <img src="../../../assets/img/zkj-success-shop.png" alt>
        <p class="text1">恭喜您成功加入购物车</p>
        <div class="item-footer">
          <button class="item-btn" @click="goToDetail">商品详情</button>
          <button class="item-btn active" @click="pay">去结算</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumbs from "../../../components/Breadcrumbs";
export default {
  name: "shopDetailSuccess",
  components: {
    "v-breadcrumbs": Breadcrumbs
  },
  computed: {
    ...mapGetters(["cartItemData"])
  },
  data() {
    return {
      breadData: [
        {
          path: "/auction",
          breadname: "拍卖中心"
        },
        {
          path: "/auction/detail",
          breadname: "拍卖详情"
        },
        {
          path: "/auction/success",
          breadname: "拍卖成功"
        }
      ]
    };
  },
  created() {
    this.breadData[1].path = "/auction/detail?id=" + this.$route.query.id;
  },
  methods: {
    //商品详情
    goToDetail() {
      this.$router.push({
        path: "/shop/detail/index",
        query: {
          id: this.$route.query.id
        }
      });
    },
    //结算
    pay() {
      // var data = JSON.stringify(this.cartItemData);
      // 跳转到购物车
      this.$router.push({
        path: "/cart/list"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-success-wrap {
  background: #fff;
  padding-bottom: 180px;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-breadcrumb {
  padding: 14px 0;
}
.jl-breadcrumb-list {
  .item {
    display: inline-block;
    vertical-align: middle;
    > a {
      font-size: 14px;
      color: #8b8b8b;
      &.active {
        color: #e50011;
      }
    }
  }
}
.jl-auc-success-content {
  padding-top: 100px;
  text-align: center;
  .text1 {
    font-size: 24px;
    color: #333;
    margin-bottom: 30px;
    margin-top: 18px;
    font-weight: bold;
  }
  .text2 {
    font-size: 14px;
    color: #e50011;
    margin-bottom: 40px;
  }
  .item-footer {
    .item-btn {
      width: 128px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 16px;
      color: #333;
      border: 1px solid #666;
      margin: 0 10px;
      background-color: #fff;
      cursor: pointer;
      &.active {
        color: #fff;
        border-color: #e50011;
        background-color: #e50011;
      }
    }
  }
}
</style>
